module.exports = __webpack_public_path__ + "img/drop__services.e286e334.svg";